import axios from 'axios';
const BASE_URL ='https://gpmtestapi.makebettinggreat.com/v1/'
//const BASE_URL = 'https://localhost:7799/v1/'
export const LOGIN_API = BASE_URL + 'account/ssoid';
export const ORDER_API = BASE_URL + 'account/order';
export const ODD_API = BASE_URL + 'bf/greyhound/odds';
export const ORDERSTTAUS_API = BASE_URL + 'account/order/';
export const CANCEL_BET_API = BASE_URL + 'account/cancel';
export const API_BF_FUND = BASE_URL + 'account/fund';
export const ORDER_UPDATE_URL = "https://rpmapi.makebettinggreat.com/v1/horse/order";
export const ORDER_FETCH_URL = "https://rpmapi.makebettinggreat.com/v1/horse/userId/order";
export const MARKET_FETCH_URL = "https://rpmapi.makebettinggreat.com/v1/horse/market/";
export const MARKET_TYPE_FETCH_URL = "https://rpmapi.makebettinggreat.com/v1/horse/market/";


export const getLoginToken = () => {
    return localStorage.getItem('bfToken');
}

export const removeLoginToken = () => {
    return localStorage.removeItem('bfToken');
}

export const clear = () => {
    removeLoginToken();
    removeUserName();
    removeBetIds();
    removeClearedBet();
    removeNewBet();
}

export const updateLoginToken = (loginToken) => {
    return localStorage.setItem('bfToken', loginToken);
}

export const updateUserName = (userName) => {
    return localStorage.setItem('userName', userName);
}

export const updateClearedBets = (cleatedBet) => {
    var existingBets = getClearedBets();
    if(!existingBets){
        existingBets = [];
    }
    let clearedBetids = cleatedBet.map(x => x.betId);
    existingBets.filter(x => clearedBetids.include(x))
    existingBets = existingBets.concat(cleatedBet);
    localStorage.setItem('clearedBet', JSON.stringify(existingBets));
}

export const getClearedBets = () => {
    const item = localStorage.getItem('clearedBet');
    return item ? JSON.parse(item)  : [];
}

export const removeClearedBet = () => {
    localStorage.removeItem('clearedBet');
}

export const removeNewBet = () => {
    localStorage.removeItem('newBetIds');
}

export const removeUserName = () => {
    return localStorage.removeItem('userName');
}

export const getUserName = () => {
    return localStorage.getItem('userName');
}

export const getBetIds = () => {
    var currentBetIds = localStorage.getItem('betIds');
    return currentBetIds ? JSON.parse(currentBetIds) : []
}


const currency_symbols = {
    USD: '$', // US Dollar
    AUD: '$',
    EUR: '€', // Euro
    CRC: '₡', // Costa Rican Colón
    GBP: '£', // British Pound Sterling
    ILS: '₪', // Israeli New Sheqel
    INR: '₹', // Indian Rupee
    JPY: '¥', // Japanese Yen
    KRW: '₩', // South Korean Won
    NGN: '₦', // Nigerian Naira
    PHP: '₱', // Philippine Peso
    PLN: 'zł', // Polish Zloty
    PYG: '₲', // Paraguayan Guarani
    THB: '฿', // Thai Baht
    UAH: '₴', // Ukrainian Hryvnia
    VND: '₫', // Vietnamese Dong
  }

export const getCurrencySymbol = (code) => {
    return currency_symbols[code];
}

export const getNewBetIds = () => {
    var currentBetIds = localStorage.getItem('newBetIds');
    return currentBetIds ? JSON.parse(currentBetIds) : []
}

export const getBetIdsFromServer = (userName) => {
    axios.get(ORDER_FETCH_URL.replace('userId', userName))
        .then((res) => {
            localStorage.setItem('betIds', JSON.stringify(res.data.map(x => x.orderId)))
        },
            (error) => {
                    //console.log("error fetching order from server:"+ error);
            });
}

export const updateBetId = (betId) => {
    var currentBetIds = localStorage.getItem('betIds');
    var newBetIds = localStorage.getItem('newBetIds');
    //save bet id to databse.
    var userName = getUserName();
    updateOrder(userName, betId);
    currentBetIds = currentBetIds ? JSON.parse(currentBetIds) : [];
    newBetIds = newBetIds ? JSON.parse(newBetIds) : [];
    currentBetIds.push(betId);
    newBetIds.push(betId);
    localStorage.setItem('betIds', JSON.stringify(currentBetIds));
    localStorage.setItem('newBetIds', JSON.stringify(newBetIds));
}

function updateOrder(userId, orderId) {
    const postRequestPara = {
        "userId": userId,
        "orderId": orderId
    }
    axios.post(ORDER_UPDATE_URL, postRequestPara)
        .then((res) => {

        },
            (error) => {
                //console.log("error updating order to server:"+ error);   
            });
}

export const removeBetIds = () => {
    return localStorage.removeItem('betIds');
}